import { useQuery, UseQueryResult } from 'react-query';
import { NotificationMessageTemplateAutoComplete, UrlParams } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

interface IUseAutoCompleteNotificationMessageTemplatesProps {
  search: string;
  notificationType: 'Email' | 'SMS' | null;
}

function useAutoCompleteNotificationMessageTemplates({
  search,
  notificationType,
}: IUseAutoCompleteNotificationMessageTemplatesProps): UseQueryResult<{
  data: Array<NotificationMessageTemplateAutoComplete>;
}> {
  const params: UrlParams = {};
  if (search) {
    params.search = search;
  }
  if (notificationType) {
    params.notification_type = notificationType;
  }

  return useQuery(['notification-message-templates-autocomplete', search, notificationType], () =>
    client.get(`notification-message-templates/auto-complete/?${encodeUrlParams(params)}`),
  );
}

export default useAutoCompleteNotificationMessageTemplates;
